/* eslint-disable */
import React, { useState } from "react";
import "./floatingSelect.scss";
// import DropIcon from "../../assets/images/dropdown-black-icon.png";
import { DropIcon } from "../../assets/images/assetsAll"

const FloatingSelect = ({
  labelName,
  inputValue,
  onChange,
  isSelected = false,
  isDisabled = false,
}) => {
  return (
    <div
      onClick={onChange}
      style={isSelected ? { paddingTop: "8px", paddingBottom: "8px" } : isDisabled ? { opacity: "0.4" } : {}}
      className="select-container"
    >
      {!isSelected && <div className="select-name">{labelName}</div>}
      {isSelected && (
        <div>
          <div className="label-name">{labelName}</div>
          <div className="input-value">{inputValue}</div>
        </div>
      )}
      <img src={DropIcon} className="drop-icon" alt="icon" />
    </div>
  );
};

export default FloatingSelect;
